import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">About</h3>
            <p className="text-emerald-100 text-sm leading-relaxed">
              The Nigeria Citizen Engagement Toolkit empowers citizens to actively participate in the legislative process and engage with their representatives.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legislature" className="text-emerald-100 hover:text-white transition-colors">
                  Understanding Legislature
                </Link>
              </li>
              <li>
                <Link to="/representatives" className="text-emerald-100 hover:text-white transition-colors">
                  Find Representative
                </Link>
              </li>
              <li>
                <Link to="/engagement-tools" className="text-emerald-100 hover:text-white transition-colors">
                  Engagement Tools
                </Link>
              </li>
              <li>
                <Link to="/templates" className="text-emerald-100 hover:text-white transition-colors">
                  Templates
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-emerald-100">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>Global Rights Office, Abuja, Nigeria</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>contact@globalrights.org</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-emerald-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-emerald-100 text-sm">
              © 2026 Global Rights. All rights reserved.
            </p>
            <div className="flex space-x-4 text-sm text-emerald-100">
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
